//
// DEV ADMIN
//

export const environment = {
  system: {
    name:       'dev',
    production: false,
    publicUrl:  'https://client-pubshop-dev.azurewebsites.net',
    adminUiUrl: 'https://client-admin-pubshop-dev.azurewebsites.net',
    version:     '1.0.0'
  },
  api: {
    url: 'https://api-pubshop-dev.azurewebsites.net/api',
    publicUrl: 'https://api-pubshop-dev.azurewebsites.net/api',
    mediaServiceUrl: 'https://ps-media-service-test.azurewebsites.net',
  },
  auth: {
    disabled: false
  }
};
